
<template>
    <div class="banner_wrap">
        <div class="banner_cont">
            <img src="../assets/image/banner_bgimg.png" />
        </div>

        <div class="banner_dvcont">
            <div class="banner_view">
                <van-swipe class="homebanner_swipe" indicator-color="#1E3C33" ref="banner" @change="bannerChange">
                    <van-swipe-item>
                        <div class="banner_item_view">
                            <div class="banner_itemone_topimg animate__animated animate__fadeInDownBig" v-if="isTwoMove">
                                <img src="../assets/image/banner_itemone_topimg.png" />
                            </div>
                            <div class="banner_itemone_downimg animate__animated animate__fadeInLeft" v-if="isThrMove">
                                <img src="../assets/image/banner_itemone_downimg.png" />
                            </div>
                            <div class="banner_itemone_bigimg animate__animated animate__fadeInLeftBig" v-if="isOneMove">
                                <img src="../assets/image/banner_itemone_bigimg.png" />
                            </div>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="banner_item_view">
                            <div class="banner_itemtwo_topimg animate__animated animate__fadeInDownBig" v-if="isTwoMove">
                                <img src="../assets/image/banner_itemtwo_topimg.png" />
                            </div>
                            <div class="banner_itemtwo_downimg animate__animated animate__fadeInLeft" v-if="isThrMove">
                                <img src="../assets/image/banner_itemtwo_downimg.png" />
                            </div>
                            <div class="banner_itemtwo_bigimg animate__animated animate__fadeInLeftBig" v-if="isOneMove">
                                <img src="../assets/image/banner_itemtwo_bigimg.png" />
                            </div>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="banner_item_view">
                            <div class="banner_itemthr_topimg animate__animated animate__fadeInDownBig" v-if="isTwoMove">
                                <img src="../assets/image/banner_itemthr_topimg.png" />
                            </div>
                            <div class="banner_itemthr_downimg animate__animated animate__fadeInLeft" v-if="isThrMove">
                                <img src="../assets/image/banner_itemthr_downimg.png" />
                            </div>
                            <div class="banner_itemthr_bigimg animate__animated animate__fadeInLeftBig" v-if="isOneMove">
                                <img src="../assets/image/banner_itemthr_bigimg.png" />
                            </div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>

        <div class="banner_btncont">
            <div class="banner_btnview">
                <div class="banner_btndv">
                    <div class="banner_btndvitem" @click.stop="onSwiperLeft">
                        <img src="../assets/image/banner_left.png" />
                    </div>
                    <div class="banner_btndvitem" @click.stop="onSwiperRight">
                        <img src="../assets/image/banner_right.png" />
                    </div>
                </div>
            </div>
        </div>


        <div class="banner_googleplay">
            <div class="banner_googleplay_cont" @click.stop="gotoGPlink">
                <img src="../assets/image/googleplay.png" />
            </div>
        </div>


    </div>
</template>

<script>
    import "./scss/banner.scss";

    export default {
        name: "banner",
        data() {
            return {
                current: 0,
                isOneMove: false,
                isTwoMove: false,
                isThrMove: false,
            };
        },
        mounted() {
            setTimeout(() => {
                this.isOneMove = true;
            }, 500);

            setTimeout(() => {
                this.isTwoMove = true;
            }, 1000);

            setTimeout(() => {
                this.isThrMove = true;
            }, 1500);
        },
        methods: {
            gotoGPlink() {
                window.location.href = 'https://play.google.com/store/apps/details?id=mx.com.paramia'
            },
            bannerChange(index) {
                console.log(index)
                this.isOneMove = false;
                this.isTwoMove = false;
                this.isThrMove = false;

                setTimeout(() => {
                    this.isOneMove = true;
                }, 500);

                setTimeout(() => {
                    this.isTwoMove = true;
                }, 1000);

                setTimeout(() => {
                    this.isThrMove = true;
                }, 1500);

            },
            onSwiperLeft() {
                this.$refs.banner.prev();
            },
            onSwiperRight() {
                this.$refs.banner.next();
            },
        }
    };
</script>
